// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__hO4C6","footer":"ModalUpdate_footer__YqOIq"};